import { SaveButton, Toolbar } from 'react-admin';
import PropTypes from 'prop-types';
import { Palette } from '@/themes/themeOverrides/Palette';

export const EditToolbar = ({ alwaysEnableSave, saving, label, icon, ...props }) => {
    return (
        <Toolbar {...props}>
            <SaveButton
                label={label}
                alwaysEnable={alwaysEnableSave}
                icon={icon}
                sx={{
                    position: 'relative',
                    minHeight: 'auto',
                    pointerEvents: saving ? 'none' : 'auto',
                    backgroundColor: saving ? Palette.gray.gray300 : Palette.yellow.yellow400,
                    color: saving ? Palette.gray.gray500 : Palette.black,
                    '& .MuiCircularProgress-root': {
                        display: 'none',
                    },
                }}
            />
        </Toolbar>
    );
};

EditToolbar.propTypes = {
    alwaysEnableSave: PropTypes.bool,
    saving: PropTypes.bool,
};
